<template>
  <div>
    <div class="card no-margin-bottom">
      <div class="card-block">
        <ui-data-table
          id="users-list"
          ref="list"
          :columns="columns"
          :filters="filters"
          :endpoint="endpoint"
          :actions="actions"
          size="sm"
        >
          <template
            slot="id"
            slot-scope="row"
          >
            <router-link :to="{ name: 'UsersEditUser', params: { id: row.id } }">
              {{ row.id }}
            </router-link>
          </template>

          <template
            slot="is_active"
            slot-scope="row"
          >
            <i
              v-if="row.is_active === true"
              class="fa fa-check text-success"
            />
            <i
                v-if="row.is_active === false"
                class="fa fa-remove text-danger"
            />
          </template>

          <template
            slot="roles"
            slot-scope="row"
          >
            <template v-if="typeof row.roles === 'object' && row.roles.length > 0">
              {{ row.roles.map(e => e.name).join(', ') }}
            </template>
            <template v-else>
              -
            </template>
          </template>

          <template
            slot="account_id"
            slot-scope="row"
          >
            <router-link :to="{ name: 'Accounts', query: { 'filter.id': '=' + row.account.id } }">
              {{ row.account.name }}
            </router-link>
          </template>
        </ui-data-table>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
import ApiService from '../services/ApiService';
import ErrorsMixins from '../mixins/ErrorsMixins';

export default {
  name: 'AppPageUsers',
  mixins: [ErrorsMixins],
  data() {
    return {
      columns: [
        {
          name: 'ID',
          key: 'id',
          sorting: true,
          styles: 'text-right',
        },
        {
          name: this.$t('Email'),
          key: 'email',
          sorting: true,
        },
        {
          name: this.$t('Account name'),
          key: 'account_id',
          sorting: true,
        },
        {
          name: this.$t('First name'),
          key: 'first_name',
          sorting: true,
        },
        {
          name: this.$t('Last name'),
          key: 'last_name',
          sorting: true,
        },
        {
          name: this.$tc('Roles', 2),
          key: 'roles',
        },
        {
          name: this.$t('Enabled'),
          key: 'is_active',
          sorting: true,
          styles: 'text-center',
        },
      ],
      filters: [
        {
          name: 'ID',
          key: 'id',
          type: 'integer',
        },
        {
          name: this.$t('Email'),
          key: 'email',
          type: 'string',
        },
        {
          name: this.$t('Account ID'),
          key: 'account_id',
          type: 'integer',
        },
        {
          name: this.$t('First name'),
          key: 'first_name',
          type: 'string',
        },
        {
          name: this.$t('Last name'),
          key: 'last_name',
          type: 'string',
        },
      ],
      endpoint: `${ApiService.getLink('users')}&includes=account,roles`,
      actions: [
        {
          icon: 'fa fa-plus',
          action: () => {
            this.$router.push({ name: 'UsersCreateUser' });
          },
          label: this.$t('Create object', { object: this.$tc('Users', 1).toLowerCase() }),
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
  .role-badge {
    margin-right: 3px;
  }
</style>
